<template>
  <section id="pipeline">
    <div class="row">
      <div class="col-md-12">
        <div class="card mt-1" style="min-height: 450px">
          <div class="pipeline-controls desktop-only m-3">
            <h6 style="font-weight: 700">Pipelines</h6>
            <div class="controls-wrap d-flex align-items-center no-mobile">
              <div class="input-group">
                <Search placeholderText="Search (name)" @search="handleSearch" />

                <div class="mr-2">
                  <!-- Qualification -->
                  <DropdownCheckbox
                    style="min-width: 250px"
                    :options="[
                      { id: 1, qualification: 'Not contacted' },
                      { id: 8, qualification: 'Qualifying' },
                      { id: 2, qualification: 'Contacted' },
                      { id: 7, qualification: 'Responded' },
                      { id: 3, qualification: 'Interviewing' },
                      { id: 4, qualification: 'Submitted' },
                      { id: 5, qualification: 'No longer interested' },
                      { id: 6, qualification: 'Not in consideration' },
                    ]"
                    v-model="selectedQualifications"
                    @input="handleQualificationFilter($event, 'qualifications')"
                    name="pipeline-qualification-filter"
                    placeholder="Qualifcation"
                    label="qualification"
                  />
                  <!-- End Qualification -->

                  <!-- Stages -->
                  <!--        <DropdownCheckbox
                    v-else
                    style="min-width: 250px"
                    :options="[
                      { id: 101, stage: 'Not submitted' },
                      { id: 102, stage: 'Not contacted' },
                      { id: 103, stage: 'Contacted' },
                      { id: 104, stage: 'Interviewing' },
                      { id: 106, stage: 'Offered employment' },
                      { id: 107, stage: 'Employed' },
                      { id: 108, stage: 'No longer interested' },
                      { id: 109, stage: 'Not in consideration' },
                    ]"
                    v-model="selectedStages"
                    @input="handleStageFilter($event, 'stages')"
                    name="pipeline-stage-filter"
                    placeholder="Stage"
                    label="stage"
                  /> -->
                </div>
                <!-- End Stages -->

                <!-- Sources -->
                <div class="empl">
                  <v-select
                    style="min-width: 250px"
                    v-model="selectedSources"
                    @input="handleSourceFilter"
                    :options="getSourceList"
                    placeholder="Source"
                    inputId="sources-select"
                    label="source_name"
                    multiple
                    :reduce="source => source"
                    :clearable="false"
                    ><template #option="{ source_name, description }">
                      {{ description }} ({{ source_name }})
                    </template>
                  </v-select>
                </div>
                <!-- End Sources -->
              </div>

              <button
                data-toggle="modal"
                data-target="#jobPipelineAddExistingCandidateModal"
                type="button"
                class="btn btn-primary mr-3 ml-3"
                style="white-space: nowrap"
                :disabled="disabledButton"
              >
                Add Existing Candidate
              </button>

              <!-- Add Existing Candidate Modal -->
              <div
                class="modal fade edit-modal"
                id="jobPipelineAddExistingCandidateModal"
                tabindex="-1"
                aria-labelledby="jobPipelineAddExistingCandidateModalLabel"
                aria-hidden="true"
                role="dialog"
                data-backdrop="static"
              >
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">Add Existing Candidate</h5>
                      <button
                        type="button"
                        class="close"
                        ref="jobPipelineAddExistingCandidateModalClose"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>

                    <div class="modal-body existing-candidate text-center justify-content-center">
                      <div class="form-group m-label-left">
                        <v-select
                          id="select-candidate"
                          v-model="selectedCandidate"
                          @search="handleSelectedCandidates"
                          :options="getExistingCandidates"
                          label="name"
                          :reduce="candidate => candidate"
                          :clearable="false"
                        >
                          <template #option="{ first_name, last_name, email }">
                            {{ `${first_name} ${last_name}` }}
                            <em>{{ email ? ` - ${email}` : '' }}</em>
                          </template>
                          <template #selected-option="{ first_name, last_name, email }">
                            {{ first_name }} {{ last_name }}
                            <em>{{ email ? ` - ${email}` : '' }}</em>
                          </template>
                          <template v-slot:no-options="{ search, searching }">
                            <template v-if="searching && search.length >= 3">
                              No results found for <em>{{ search }}</em
                              >.
                            </template>
                            <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                          </template>
                        </v-select>
                        <label for="candidatew">Select candidate</label>
                      </div>

                      <div class="form-group m-label-left">
                        <select v-model="existingCandidateSelectedSource" class="form-control my-3">
                          <option
                            v-for="source in getSourceList"
                            :value="source.id"
                            :key="source.id"
                          >
                            {{ source.description }} ({{ source.source_name }})
                          </option>
                        </select>
                        <label for="select-candidate">Source</label>
                      </div>
                    </div>

                    <div class="modal-footer text-center justify-content-center">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="
                          onAddExistingCandidate(selectedCandidate, existingCandidateSelectedSource)
                        "
                      >
                        Add
                      </button>

                      <button
                        @click="onCancelAddExistingCandidate"
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End Add Existing Candidate Modal -->

              <button
                @click="showModal = true"
                type="button"
                class="btn btn-success"
                style="white-space: nowrap"
                :disabled="disabledButton"
              >
                Add New Candidate
                <portal to="add-candidate-modal">
                  <CustomMainModal @close="closeModal" v-show="showModal">
                    <template v-slot:header>
                      <h5>Add Candidate</h5>
                    </template>
                    <!-- {{ $route.params.job_uuid }} -->

                    <AddCandidateBtnModal
                      v-if="showModal"
                      @close="closeModal"
                      :job_uuid="$route.params.job_uuid"
                    />
                  </CustomMainModal>
                </portal>
              </button>
              <portal-target name="add-candidate-modal"></portal-target>
            </div>
          </div>

          <div class="table-responsive desktop-only">
            <table class="table table-striped custom-table" style="table-layout: auto">
              <thead class="bg-dark text-white">
                <tr>
                  <th scope="col" style="width: 12%">RATING</th>
                  <th scope="col" style="width: 13%">NAME</th>
                  <th scope="col">LOCATION</th>
                  <th scope="col">
                    <!-- DOCUMENTS -->
                    &nbsp;
                  </th>
                  <th scope="col">
                    <!-- DOCUMENTS -->
                    &nbsp;
                  </th>
                  <th scope="col">SOURCE</th>
                  <th scope="col">UPDATED</th>
                  <th scope="col">QUALIFICATION</th>
                  <th scope="col">STAGE</th>
                  <th scope="col">SEEN</th>
                  <th scope="col">ACTION</th>
                </tr>
              </thead>

              <tbody>
                <JobItemPipelineTableItem
                  v-for="pipeline in getPipelines"
                  :key="pipeline.pipeline_id"
                  :pipeline="pipeline"
                  :jobad="getJobAdById"
                  :user="getUserProfile"
                  @pipeline-reload="reloadPipelineList"
                  @pipeline-update="
                    $emit('reload-activity');
                    reloadPipelineList({ currentPage: getCurrentPage, count: 10 });
                  "
                />
              </tbody>
            </table>

            <ErrorList
              style="height: 270px;"
              class="no-data-message"
              v-show="getPipelines.length <= 0"
              name="noApplications"
            />
          </div>
          <Spinner :isLoading="isLoading" />

          <!-- Pagination -->
          <div class="d-flex justify-content-between bottom-controls">
            <div class="ml-auto mb-4">
              <Pagination
                :currentPage="getCurrentPage"
                :totalPages="getTotalPages"
                @nextPage="nextPage"
                @prevPage="previousPage"
                @keyup="keymonitor"
                @selectPageByNumber="setPageBynumber"
                @firstPage="setToFirstPage"
                @lastPage="setToLastPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Search from '../../common/Search/Search';

/* import JobStatusSelect from '../../common/JobStatusSelect'; */
import CustomMainModal from '../../Modals/CustomMainModal';
import DropdownCheckbox from '@/components/common/DropdownCheckbox/DropdownCheckbox';

import AddCandidateBtnModal from '../Candidates/AddCandidateBtnModal';
import JobItemPipelineTableItem from './JobItemPipelineTableItem';
import ErrorList from '../../common/errorsList';

import Pagination from '@/components/Navigations/Pagination';
// import { errorService } from '../../../services/errorService';

export default {
  props: {
    jobStatus: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    jobStatus(newValue, oldValue) {
      if (newValue === 4 || newValue === 5) {
        this.disabledButton = true;
      }
    },
  },
  components: {
    Search,
    /* JobStatusSelect, */
    CustomMainModal,
    AddCandidateBtnModal,
    Pagination,
    ErrorList,
    JobItemPipelineTableItem,
    DropdownCheckbox,
  },

  data: () => ({
    hasTest: false,
    selectedSources: [],
    selectedStages: [],
    selectedQualifications: [],
    searchPhrase: '',
    selectedCandidate: {},
    existingCandidatesOptions: [],
    showModal: false,
    source: '',
    isLoading: false,
    candidateDocumentsFiles: [],
    selectedDocuments: [],
    pipelineForSubmit: {},
    pipelineForUpdate: null,
    existingCandidateSelectedSource: '',
    currentPage: 1,
    pageCount: 10,
    disabledButton: false,
  }),
  methods: {
    ...mapActions([
      'retrieveJobsPipeline',
      'retrieveSourcesList',
      'retrieveExistingCandidates',
      'addExistingCandidate',
      'updatePipelineForCandidate',
    ]),
    onCancelAddExistingCandidate() {
      this.selectedCandidate = {};
      this.existingCandidateSelectedSource = '';
    },
    handleSearch(searchPhrase) {
      this.searchPhrase = searchPhrase;
      this.doSearch();
    },
    handleQualificationFilter() {
      this.doSearch();
    },
    handleStageFilter() {
      this.doSearch();
    },
    handleSourceFilter() {
      this.doSearch();
    },
    reloadPipelineList({ currentPage, count }) {
      this.retrieveJobsPipeline({
        js_employer_jobad_id: this.$route.params.job_uuid,
        search_word: '',
        stages: this.selectedStages.map(stage => stage.id),
        qualifications: this.selectedQualifications.map(qualification => qualification.id),
        page: currentPage,
        count: count,
      });
    },
    clearForm() {},
    onAddExistingCandidate(selectedCandidate, source) {
      this.addExistingCandidate({
        jobad_id: this.$route.params.job_uuid,
        candidate_id: selectedCandidate.id,
        source_id: source,
      })
        .then(() => {
          this.isLoading = false;

          this.reloadPipelineList({ currentPage: this.getCurrentPage, count: 10 });
          this.$emit('reload-activity');

          this.$toasted.show('Candidate added', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });

          this.$refs.jobPipelineAddExistingCandidateModalClose.click();
          this.selectedCandidate = {};
          this.existingCandidateSelectedSource = [];
        })
        .catch(() => {
          this.isLoading = false;

          this.$toasted.error(
            'The candidate already exists in a pipeline with this employer and this job',
            {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            },
          );
        });
    },
    handleSelectedCandidates(search, loading) {
      if (search.length >= 3) {
        loading(true);

        this.retrieveExistingCandidates({
          search_word: search,
        })
          .then(() => {
            loading(false);
          })
          .catch(() => {
            loading(false);
          });
      }
    },
    closeModal() {
      this.currentPage = 1;
      this.showModal = false;

      this.retrieveJobsPipeline({
        js_employer_jobad_id: this.$route.params.job_uuid,
        search_word: '',
        stages: this.selectedStages.map(stage => stage.id),
        qualifications: this.selectedQualifications.map(qualification => qualification.id),
        page: this.currentPage,
        count: this.pageCount,
      });
    },
    doSearch() {
      this.currentPage = 1;

      if (this.searchPhrase.length >= 3) {
        this.isLoading = true;

        this.retrieveJobsPipeline({
          js_employer_jobad_id: this.$route.params.job_uuid,
          search_word: this.searchPhrase,
          stages: this.selectedStages.map(stage => stage.id),
          qualifications: this.selectedQualifications.map(qualification => qualification.id),
          sources: this.selectedSources.map(source => source.id),
          page: this.currentPage,
          count: this.pageCount,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }

      if (this.searchPhrase === '') {
        this.isLoading = true;

        this.retrieveJobsPipeline({
          js_employer_jobad_id: this.$route.params.job_uuid,
          search_word: this.searchPhrase,
          stages: this.selectedStages.map(stage => stage.id),
          qualifications: this.selectedQualifications.map(qualification => qualification.id),
          sources: this.selectedSources.map(source => source.id),
          page: this.currentPage,
          count: this.pageCount,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
    doPaginatedSearch() {
      this.retrieveJobsPipeline({
        js_employer_jobad_id: this.$route.params.job_uuid,
        search_word: this.searchPhrase,
        stages: this.selectedStages.map(stage => stage.id),
        qualifications: this.selectedQualifications.map(qualification => qualification.id),
        sources: this.selectedSources.map(source => source.id),
        page: this.currentPage,
        count: this.pageCount,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    nextPage() {
      if (this.currentPage >= 1 && this.currentPage < this.getTotalPages) {
        // this.isLoading = true;
        this.currentPage++;

        this.doPaginatedSearch();
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        //   this.isLoading = true;
        --this.currentPage;

        this.doPaginatedSearch();
      } else {
        this.currentPage = 1;
      }
    },
    setToFirstPage() {
      //  this.isLoading = true;
      this.currentPage = 1;

      this.doPaginatedSearch();
    },
    setToLastPage(lastPage) {
      //  this.isLoading = true;
      this.currentPage = lastPage;

      this.doPaginatedSearch();
    },
    setPageBynumber(pageNumber) {
      if (pageNumber > this.getTotalPages || pageNumber < 1) return;
      this.currentPage = Number(pageNumber);

      this.doPaginatedSearch();
    },
    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      const activeModal = document.querySelector('.modal.show');

      if (activeModal) {
        // Modal is visible, so we stop further execution
        return;
      }

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        this.previousPage();
      }
    },
  },
  computed: {
    ...mapGetters([
      'getUserProfile',
      'getSourceList',
      'getPipelines',
      'getExistingCandidates',
      'getCurrentPage',
      'getTotalPages',
      'getJobAdById',
      'getUserProfile',
      'getAccType',
    ]),
  },
  mounted() {
    this.retrieveJobsPipeline({
      js_employer_jobad_id: this.$route.params.job_uuid,
      search_word: '',
      stages: this.selectedStages.map(stage => stage.id),
      qualifications: this.selectedQualifications.map(qualification => qualification.id),
      page: this.currentPage,
      count: this.pageCount,
    });

    /*  this.retrieveSourcesList().then((res) => {
      this.existingCandidateSelectedSource = res.data[0].id;
    }); */
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

/* Stages */

#pipeline {
  overflow: hidden;
}

.dropdown {
  button {
    box-shadow: 0px 2px 3px #0000000d;
    background: url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='14' height='14' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='grey'/></g></svg>")
      no-repeat !important;
    background-position: right 3px top 50% !important;
    margin-right: 8px !important;
    -webkit-appearance: none;
    -moz-appearance: none;

    &::after {
      display: none;
      /*  -webkit-appearance: none;
      -moz-appearance: none; */
    }
    color: #4d4f5c;
  }

  .dropdown-menu {
    padding: 8px 12px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
    ul > li:not(:last-child) {
      margin-bottom: 1rem;
    }

    width: 250px;
    margin-top: 5px;

    .custom-control {
      margin-bottom: 0;
    }
  }

  button {
    background-color: #fff;
    border: 1px solid #d7dae2;
    border-radius: 4px;
    width: 250px;
    text-align: left;
  }
}

h6 {
  font-size: 18px;
}

.mobile-only {
  display: none !important;
}

@media only screen and (max-width: 768px) {
  #stages-dropdown {
    flex: 1;
    .dropdown-toggle {
      width: 100%;
    }
  }
  .btn-success {
    display: none !important;
  }
}

@media only screen and (max-width: 576px) {
  .dropdown.ml-3 {
    margin-left: 0 !important;
    .btn {
      width: 100%;
      margin: 12px 0;
    }
  }
}
/* End Stages */

@media only screen and (max-width: 992px) {
  .card {
    border-radius: 0;
    margin-top: 12px !important;
    border: none;
    h6 {
      margin: 0 12px 0px 25px;
      font-size: 18px;
    }
    .mx-2 {
      margin: 0 !important;
    }
    .col-md-12 {
      padding: 0;
    }
    .my-4 {
      margin: 0 !important;
    }
    .pipeline-controls {
      margin: 0 !important;
      padding: 0 12px;
      .no-mobile {
        display: none !important;
      }
    }
    .controls-wrap {
      display: block !important;
      .form-control {
        margin: 12px 0 !important;
      }
      .select-style {
        display: block;
        width: 100% !important;
      }
      .btn-primary,
      .btn-success {
        width: 48%;
        text-align: center;
        margin-bottom: 12px;
        i {
          display: none;
        }
      }
    }
  }
  .bottom-controls,
  .no-mobile {
    display: none !important;
  }
  .list-unstyled.mobile-pipeline {
    margin-top: -10px;
    padding: 0 25px;
    font-family: $font-family-sans-lato;
    li {
      position: relative;
      padding: 6px 20px 6px 20px;
      border-bottom: 1px solid #ddd;
      a.username {
        display: block;
        font-size: 16px;
        font-weight: 700;
        text-decoration: none;
      }

      a.toggle-collapse {
        color: #666;
        position: absolute;
        top: 50%;
        right: -2px;
        transform: translate(0, -50%);
      }

      .d-flex:first-of-type {
        span {
          font-size: 14px;
          &:first-of-type {
            color: $color-orange;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
          }
        }
      }

      .d-flex:nth-of-type(2) {
        span {
          font-size: 14px;

          &:first-of-type {
            color: #5f5f5f;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
            position: relative;
            .status {
              border-radius: 50%;
              display: inline-block;
              width: 11px;
              height: 11px;
              background: red;
              margin: 0px 5px 0 0;
              &.employment {
                background: $color-status-active;
              }
              &.self-employment {
                background: $color-base-blue;
              }
              &.mixed-orange {
                background: $color-orange;
              }
            }
          }
        }
      }
      img {
        position: absolute;
        top: 8px;
        right: 12px;
      }
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
}

@media only screen and (max-width: 768px) {
  .card {
    border-radius: 0;
    margin-top: 12px !important;
    border: none;
    h6 {
      margin: 0 12px 0px 25px;
      font-size: 18px;
    }
    .mx-2 {
      margin: 0 !important;
    }
    .col-md-12 {
      padding: 0;
    }
    .my-4 {
      margin: 0 !important;
    }
    .pipeline-controls {
      margin: 0 !important;
      padding: 0 12px;
      .no-mobile {
        display: none !important;
      }
    }
    .controls-wrap {
      display: block !important;
      .form-control {
        margin: 12px 0 !important;
      }
      .select-style {
        display: block;
        width: 100% !important;
      }
      .btn-primary,
      .btn-success {
        width: 48%;
        text-align: center;
        margin-bottom: 12px;
        i {
          display: none;
        }
      }
    }
  }
  .bottom-controls,
  .no-mobile {
    display: none !important;
  }
  .list-unstyled.mobile-pipeline {
    margin-top: -10px;
    padding: 0 25px;
    font-family: $font-family-sans-lato;
    li {
      position: relative;
      padding: 6px 20px 6px 20px;
      border-bottom: 1px solid #ddd;
      a.username {
        display: block;
        font-size: 16px;
        font-weight: 700;
        text-decoration: none;
      }

      a.toggle-collapse {
        color: #666;
        position: absolute;
        top: 50%;
        right: -2px;
        transform: translate(0, -50%);
      }

      .d-flex:first-of-type {
        span {
          font-size: 14px;
          &:first-of-type {
            color: $color-orange;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
          }
        }
      }

      .d-flex:nth-of-type(2) {
        span {
          font-size: 14px;

          &:first-of-type {
            color: #5f5f5f;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
            position: relative;
            .status {
              border-radius: 50%;
              display: inline-block;
              width: 11px;
              height: 11px;
              background: red;
              margin: 0px 5px 0 0;
              &.employment {
                background: $color-status-active;
              }
              &.self-employment {
                background: $color-base-blue;
              }
              &.mixed-orange {
                background: $color-orange;
              }
            }
          }
        }
      }
      img {
        position: absolute;
        top: 8px;
        right: 12px;
      }
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
}

@media only screen and (max-width: 576px) {
  .card {
    border-radius: 0;
    margin-top: 12px !important;
    border: none;
    h6 {
      margin: 0 12px 0px 25px;
      font-size: 18px;
    }
    .mx-2 {
      margin: 0 !important;
    }
    .col-md-12 {
      padding: 0;
    }
    .my-4 {
      margin: 0 !important;
    }
    .pipeline-controls {
      margin: 0 !important;
      padding: 0 12px;
      .no-mobile {
        display: none !important;
      }
    }
    .controls-wrap {
      display: block !important;
      .form-control {
        margin: 12px 0 !important;
      }
      .select-style {
        display: block;
        width: 100% !important;
      }
      .btn-primary,
      .btn-success {
        width: 48%;
        text-align: center;
        margin-bottom: 12px;
        i {
          display: none;
        }
      }
    }
  }
  .bottom-controls,
  .no-mobile {
    display: none !important;
  }
  .list-unstyled.mobile-pipeline {
    position: relative;
    margin: -4px 0 0 0;
    padding: 0 25px;
    font-family: $font-family-sans-lato;
    li {
      position: relative;
      padding: 6px 12px 6px 8px;
      border-bottom: 1px solid #ddd;
      a.username {
        display: block;
        font-size: 16px;
        font-weight: 700;
        text-decoration: none;
      }

      a.toggle-collapse {
        color: #666;
        position: absolute;
        top: 50%;
        right: -2px;
        transform: translate(0, -50%);
      }

      .d-flex:first-of-type {
        span {
          font-size: 14px;
          &:first-of-type {
            color: $color-orange;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
          }
        }
      }

      .d-flex:nth-of-type(2) {
        span {
          font-size: 14px;

          &:first-of-type {
            color: #5f5f5f;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
            position: relative;
            .status {
              border-radius: 50%;
              display: inline-block;
              width: 11px;
              height: 11px;
              background: red;
              margin: 0px 5px 0 0;
              &.employment {
                background: $color-status-active;
              }
              &.self-employment {
                background: $color-base-blue;
              }
              &.mixed-orange {
                background: $color-orange;
              }
            }
          }
        }
      }
      img {
        position: absolute;
        top: 8px;
        right: 12px;
      }
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
}
</style>
